import * as React from "react";
import {Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button} from "@material-ui/core";
import {LocalizerHelper} from "../../helpers/localizerHelper";
import './index.scss';

const ErrorDialog = ({open, error, handleClose}: {open: boolean, error: any, handleClose: () => any}) => (
    <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth={true}
        classes={{
            container: 'error-dialog'
        }}
        aria-labelledby="draggable-dialog-title">
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            <span className="dialog-title">{LocalizerHelper.localized('error')}</span>
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {error?.message ?? error?.toString() ?? ''}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button className="close-button" onClick={handleClose} color="primary">
                {LocalizerHelper.localized('ok')}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ErrorDialog;
